function setFullscreenHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  setFullscreenHeight();
  
  let currentOrientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  
  window.addEventListener('resize', () => {
    const newOrientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  
    if (newOrientation !== currentOrientation) {
      currentOrientation = newOrientation;
      setFullscreenHeight();
    }
  });

document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.dn-burger').addEventListener('click', function () {
    const body = document.body;

    if (!body.classList.contains('dn-mobile-menu-active')) {
      body.classList.add('dn-mobile-menu-active');
      body.classList.remove('dn-mobile-menu-inactive');
    } else {
      body.classList.remove('dn-mobile-menu-active');
      body.classList.add('dn-mobile-menu-inactive');
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 992) {
      document.body.classList.remove('dn-mobile-menu-active');
    }
  });

  const header = document.querySelector('.dn-header');

  window.addEventListener('scroll', function () {
    if (window.scrollY > 30) {
      header.classList.add('dn-header-scrolled');
    } else {
      header.classList.remove('dn-header-scrolled');
    }
  });
});

// Header hover
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.dn-header');

  header.addEventListener('mouseenter', () => {
    //header.classList.add('dn-header-scrolled');
  });

  header.addEventListener('mouseleave', () => {
    //header.classList.remove('dn-header-scrolled');
  });
});

// Submenu
document.addEventListener('DOMContentLoaded', () => {
  const icons = document.querySelectorAll('.dn-submenu-icon');

  icons.forEach(icon => {
    icon.addEventListener('click', e => {
      e.preventDefault();
      const parentLi = icon.closest('.dn-main-nav-li');
      const submenu = parentLi.querySelector('.dn-sub-nav-ul');

      if (parentLi.classList.contains('submenu-open')) {
        // Zuklappen
        submenu.style.height = submenu.scrollHeight + 'px'; // Startwert
        requestAnimationFrame(() => {
          submenu.style.height = '0';
          submenu.style.opacity = 0;
        });
        submenu.addEventListener('transitionend', function handler() {
          submenu.style.height = '';
          submenu.removeEventListener('transitionend', handler);
        });
        parentLi.classList.remove('submenu-open');
      } else {
        // Aufklappen
        parentLi.classList.add('submenu-open');
        submenu.style.height = submenu.scrollHeight + 'px';
        submenu.style.opacity = 1;

        submenu.addEventListener('transitionend', function handler() {
          submenu.style.height = 'auto'; // Danach dynamisch
          submenu.removeEventListener('transitionend', handler);
        });
      }
    });
  });
});

// Accordion
document.addEventListener('DOMContentLoaded', () => {
  const headers = document.querySelectorAll('.dn-accordion-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.dn-accordion-item');
      const content = item.querySelector('.dn-accordion-content');

      if (item.classList.contains('active')) {
        // Schließen
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.height = '0';
          content.style.opacity = 0;
        });
        item.classList.remove('active');
      } else {
        // Öffnen
        item.classList.add('active');
        content.style.height = content.scrollHeight + 'px';
        content.style.opacity = 1;

        content.addEventListener('transitionend', function handler() {
          content.style.height = 'auto'; // Danach flexibel
          content.removeEventListener('transitionend', handler);
        });
      }
    });
  });
});

// Countdown
  document.addEventListener("DOMContentLoaded", function () {
    // Prüfen, ob Countdown-Container vorhanden ist
    const countdownEl = document.getElementById("countdown");
    if (!countdownEl) return; // Script sofort abbrechen, wenn kein Countdown da

    const daysEl = document.getElementById("countdown_days");
    const hoursEl = document.getElementById("countdown_hours");
    const minutesEl = document.getElementById("countdown_minutes");
    const secondsEl = document.getElementById("countdown_seconds");

    // Zieldatum festlegen (Jahr, Monat-1, Tag, Stunde, Minute, Sekunde)
    const targetDate = new Date(2026, 6, 4, 0, 0, 0); // 30. August 2025 Mitternacht

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      // Wenn Zielzeit erreicht oder überschritten: alles auf 0
      if (distance <= 0) {
        daysEl.textContent = 0;
        hoursEl.textContent = 0;
        minutesEl.textContent = 0;
        secondsEl.textContent = 0;
        return false; // signalisiert: Countdown fertig
      }

      // Berechnungen für Tage, Stunden, Minuten, Sekunden
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Werte einsetzen
      daysEl.textContent = days;
      hoursEl.textContent = hours;
      minutesEl.textContent = minutes;
      secondsEl.textContent = seconds;

      return true; // signalisiert: Countdown läuft noch
    }

    // Direkt beim Laden einmal ausführen
    updateCountdown();

    // Dann jede Sekunde aktualisieren – nur solange Countdown läuft
    const timer = setInterval(() => {
      if (!updateCountdown()) clearInterval(timer);
    }, 1000);
  });

// Formular
document.querySelectorAll('.dn-custom-file input[type="file"]').forEach(input => {
  input.addEventListener('change', e => {
    const fileName = input.files[0] ? input.files[0].name : 'Keine Datei';
    input.closest('.dn-custom-file').querySelector('.dn-filename').textContent = fileName;
  });
});

if (typeof flatpickr !== "undefined") {
  flatpickr(".dn-datepicker", {
    dateFormat: "Y-m-d",
    altInput: true,
    altFormat: "d.m.Y",
    allowInput: true
  });

  flatpickr(".dn-timepicker", {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true
  });
}

function initTicketparkEmbed() {
  const el = document.querySelector("#my-ticket-shop");
  if (!el || el.dataset.initialized === "true") return;

  function tryInit(attempt = 0) {
    if (typeof ticketpark !== "undefined") {
      new ticketpark.Auto("#my-ticket-shop", {
        pid: "5CB5239C-D824-4EA4-A587-7A3D000760F2",
        language: "de",
        requireInvitationCode: true,
        invitationPrefix: "GO26_",
        texts: {
          de: {
            title_invitation_key: "Geben Sie einen Ihrer Gutscheincodes ein um Zugang zu erhalten. Beachten Sie, dass der Gutschein anschliessend im Warenkorb nochmals angerechnet werden muss.",
            label_invitation_key: "Gutscheincode eingeben um Zugang zu erhalten:"
          }
        }
      });

      el.dataset.initialized = "true";
    } else if (attempt < 50) {
      setTimeout(() => tryInit(attempt + 1), 100);
    } else {
      console.error("ticketpark konnte nicht geladen werden.");
    }
  }

  tryInit();
}

document.addEventListener("DOMContentLoaded", initTicketparkEmbed);

document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(ScrollTrigger);

  const initParallax = () => {
    const el = document.querySelector('.dn-image-parallax');
    if (!el) {
      // Try again after a short delay if element hasn't appeared yet
      setTimeout(initParallax, 100);
      return;
    }

    gsap.to(el, {
      y: -100,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        scrub: true
      }
    });
  };

  initParallax();
});

// Festgelaende map
document.addEventListener('DOMContentLoaded', () => {
  const maps = document.querySelectorAll('[data-fg-map]');

  maps.forEach((mapRoot) => {
    const stage = mapRoot.querySelector('[data-fg-stage]');
    const canvas = mapRoot.querySelector('[data-fg-canvas]');
    const zoomInButton = mapRoot.querySelector('[data-fg-zoom-in]');
    const zoomOutButton = mapRoot.querySelector('[data-fg-zoom-out]');
    const resetButton = mapRoot.querySelector('[data-fg-reset]');
    const controls = mapRoot.querySelector('.dn-fg-controls');
    const activeTitle = mapRoot.querySelector('[data-fg-active-title]');
    const filterToggle = mapRoot.querySelector('[data-fg-filter-toggle]');
    const filterPanel = mapRoot.querySelector('[data-fg-filter-panel]');
    const filterCloseTargets = Array.from(mapRoot.querySelectorAll('[data-fg-filter-close]'));
    const modal = mapRoot.querySelector('[data-fg-modal]');
    const modalDialog = mapRoot.querySelector('.dn-fg-modal-dialog');
    const modalTitle = mapRoot.querySelector('[data-fg-modal-title]');
    const modalNumber = mapRoot.querySelector('[data-fg-modal-number]');
    const modalMapLink = mapRoot.querySelector('[data-fg-modal-map-link]');
    const modalCloseTargets = Array.from(mapRoot.querySelectorAll('[data-fg-modal-close]'));
    const modalCloseButton = mapRoot.querySelector('.dn-fg-modal-close');
    const filterCloseButton = mapRoot.querySelector('.dn-fg-filter-close');
    const fullscreenButton = mapRoot.querySelector('[data-fg-fullscreen]');

    if (!canvas || !stage) return;

    const minZoom = 1;
    const desktopMaxZoom = 5;
    const mobileMaxZoom = 9;
    const zoomStep = 0.4;
    let zoom = 1;
    let panX = 0;
    let panY = 0;
    let dragStart = null;
    let pinchStart = null;
    let gestureMoved = false;
    let suppressMarkerClick = false;
    const activePointers = new Map();
    const DRAG_THRESHOLD = 6;
    const mapSvgElement = mapRoot.querySelector('.dn-fg-map-svg svg');
    let mapAspectRatio = 1200 / 760;
    if (mapSvgElement) {
      const vb = mapSvgElement.getAttribute('viewBox');
      if (vb) {
        const parts = vb.trim().split(/\s+/).map(Number);
        if (parts.length === 4 && parts[2] > 0 && parts[3] > 0) {
          mapAspectRatio = parts[2] / parts[3];
        }
      }
    }
    let fitWidthRatio = 1;
    let fitHeightRatio = 1;
    let fitLeftRatio = 0;
    let fitTopRatio = 0;

    const markers = Array.from(mapRoot.querySelectorAll('[data-fg-marker]'));
    const filterInputs = Array.from(mapRoot.querySelectorAll('[data-fg-filter-group], [data-fg-filter]'));
    let lastFocusedElement = null;
    let lastModalTrigger = null;
    let releaseModalFocusTrap = null;
    let releaseFilterFocusTrap = null;
    let isMapFullscreen = false;

    const getFocusableElements = (container) => {
      if (!container) return [];
      return Array.from(container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter((element) => {
        const node = element;
        return !node.hidden && node.getClientRects().length > 0;
      });
    };

    const createFocusTrap = (container, initialElement) => {
      if (!container) return () => {};

      const onKeydown = (event) => {
        if (event.key !== 'Tab') return;

        const focusables = getFocusableElements(container);
        if (!focusables.length) {
          event.preventDefault();
          container.focus();
          return;
        }

        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;

        if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        } else if (event.shiftKey && active === first) {
          event.preventDefault();
          last.focus();
        }
      };

      container.addEventListener('keydown', onKeydown);

      const focusables = getFocusableElements(container);
      if (initialElement && typeof initialElement.focus === 'function') {
        initialElement.focus();
      } else if (focusables.length) {
        focusables[0].focus();
      } else if (typeof container.focus === 'function') {
        container.focus();
      }

      return () => {
        container.removeEventListener('keydown', onKeydown);
      };
    };

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const getMaxZoom = () => {
      const stageWidth = Math.max(stage.clientWidth || 0, 1);
      return stageWidth < 992 ? mobileMaxZoom : desktopMaxZoom;
    };

    const getMarkerScale = () => {
      const stageWidth = Math.max(stage.clientWidth || 0, 1);
      const isMobileLike = stageWidth < 992;

      if (isMobileLike) {
        // Mobile/tablet: markers should stay easy to hit and grow slightly while zooming in.
        const zoomGrowth = Math.pow(zoom, 0.18);
        return clamp(0.9 * zoomGrowth, 0.94, 1.12);
      }

      // Desktop: compact at 100%, slightly larger while zooming in.
      const base = stageWidth >= 1200 ? 0.92 : 0.96;
      const zoomGrowth = Math.pow(zoom, 0.18);
      return clamp(base * zoomGrowth, 0.88, 1.45);
    };

    const syncMapFitFrame = () => {
      const stageWidth = Math.max(stage.clientWidth || 0, 1);
      const stageHeight = Math.max(stage.clientHeight || 0, 1);
      const stageRatio = stageWidth / stageHeight;

      let fitWidth = stageWidth;
      let fitHeight = stageHeight;
      let fitLeft = 0;
      let fitTop = 0;

      if (stageRatio > mapAspectRatio) {
        fitHeight = stageHeight;
        fitWidth = fitHeight * mapAspectRatio;
        fitLeft = (stageWidth - fitWidth) / 2;
      } else if (stageRatio < mapAspectRatio) {
        fitWidth = stageWidth;
        fitHeight = fitWidth / mapAspectRatio;
        fitTop = (stageHeight - fitHeight) / 2;
      }

      fitWidthRatio = fitWidth / stageWidth;
      fitHeightRatio = fitHeight / stageHeight;
      fitLeftRatio = fitLeft / stageWidth;
      fitTopRatio = fitTop / stageHeight;

      canvas.style.setProperty('--fg-map-fit-left', `${(fitLeftRatio * 100).toFixed(4)}%`);
      canvas.style.setProperty('--fg-map-fit-top', `${(fitTopRatio * 100).toFixed(4)}%`);
      canvas.style.setProperty('--fg-map-fit-width', `${(fitWidthRatio * 100).toFixed(4)}%`);
      canvas.style.setProperty('--fg-map-fit-height', `${(fitHeightRatio * 100).toFixed(4)}%`);
    };

    const getBounds = (nextZoom = zoom) => {
      const stageWidth = stage.clientWidth;
      const stageHeight = stage.clientHeight;
      const contentWidth = stageWidth * fitWidthRatio * nextZoom;
      const contentHeight = stageHeight * fitHeightRatio * nextZoom;
      const offsetX = stageWidth * fitLeftRatio * nextZoom;
      const offsetY = stageHeight * fitTopRatio * nextZoom;
      const epsilon = 2;
      const canPanX = contentWidth - stageWidth > epsilon;
      const canPanY = contentHeight - stageHeight > epsilon;

      const centeredX = ((stageWidth - contentWidth) / 2) - offsetX;
      const centeredY = ((stageHeight - contentHeight) / 2) - offsetY;

      const minX = canPanX
        ? (stageWidth - contentWidth - offsetX)
        : centeredX;
      const maxX = canPanX
        ? -offsetX
        : centeredX;
      const minY = canPanY
        ? (stageHeight - contentHeight - offsetY)
        : centeredY;
      const maxY = canPanY
        ? -offsetY
        : centeredY;

      return { minX, maxX, minY, maxY };
    };

    const clampPan = () => {
      const { minX, maxX, minY, maxY } = getBounds();
      panX = clamp(panX, minX, maxX);
      panY = clamp(panY, minY, maxY);
    };

    const applyTransform = (withTransition = false, skipClamp = false) => {
      canvas.classList.toggle('is-animated', withTransition);
      const zoomPercent = `${(zoom * 100).toFixed(3)}%`;
      canvas.style.width = zoomPercent;
      canvas.style.height = zoomPercent;
      if (!skipClamp) {
        clampPan();
      }
      canvas.style.transform = `translate(${panX}px, ${panY}px)`;
      const markerScale = getMarkerScale();
      mapRoot.style.setProperty('--fg-marker-scale', markerScale.toFixed(3));
      if (zoomInButton) zoomInButton.disabled = zoom >= getMaxZoom();
      if (zoomOutButton) zoomOutButton.disabled = zoom <= minZoom;
      if (resetButton) resetButton.disabled = zoom === 1 && panX === 0 && panY === 0;
    };

    const setZoomAtPoint = (nextZoom, clientX, clientY) => {
      const targetZoom = clamp(nextZoom, minZoom, getMaxZoom());
      if (targetZoom === zoom) return;

      const rect = stage.getBoundingClientRect();
      const localX = clientX - rect.left;
      const localY = clientY - rect.top;

      const contentX = (localX - panX) / zoom;
      const contentY = (localY - panY) / zoom;

      zoom = targetZoom;
      panX = localX - contentX * zoom;
      panY = localY - contentY * zoom;
      gestureMoved = true;
      applyTransform();
    };

    const setZoomByStep = (direction) => {
      const rect = stage.getBoundingClientRect();
      const focusX = rect.left + rect.width / 2;
      const focusY = rect.top + rect.height / 2;
      setZoomAtPoint(Number((zoom + direction * zoomStep).toFixed(2)), focusX, focusY);
    };

    const syncDesktopFilterPanelHeight = () => {
      if (!filterPanel) return;
      const isDesktop = window.matchMedia('(min-width: 992px)').matches;
      if (!isDesktop) {
        filterPanel.style.height = '';
        filterPanel.style.maxHeight = '';
        return;
      }

      const stageHeight = stage.clientHeight;
      if (stageHeight > 0) {
        const px = `${stageHeight}px`;
        filterPanel.style.height = px;
        filterPanel.style.maxHeight = px;
      }
    };

    const setActiveMarker = (marker) => {
      markers.forEach((entry) => entry.classList.remove('is-active'));

      if (!marker) {
        if (activeTitle) activeTitle.textContent = 'Wähle einen Marker auf der Karte.';
        return;
      }

      marker.classList.add('is-active');
      if (activeTitle) activeTitle.textContent = marker.dataset.fgTitle || '';
    };

    const openModal = (marker) => {
      if (!modal || !marker) return;
      lastModalTrigger = marker;
      lastFocusedElement = document.activeElement;
      if (modalTitle) modalTitle.textContent = marker.dataset.fgTitle || '';
      if (modalNumber) {
        const iconUrl = marker.dataset.fgIcon || '';
        const bubbleColor = (marker.dataset.fgBubbleColor || '').trim();
        if (bubbleColor) {
          modalNumber.style.setProperty('--fg-bubble-color', bubbleColor);
        } else {
          modalNumber.style.removeProperty('--fg-bubble-color');
        }
        if (iconUrl) {
          modalNumber.innerHTML = `<img src="${iconUrl}" alt="" aria-hidden="true">`;
          modalNumber.classList.add('is-icon');
        } else {
          modalNumber.textContent = marker.dataset.fgNumber || '';
          modalNumber.classList.remove('is-icon');
        }
      }
      if (modalMapLink) {
        const mapLink = (marker.dataset.fgMapLink || '').trim();
        if (/^https?:\/\//i.test(mapLink)) {
          modalMapLink.href = mapLink;
          modalMapLink.hidden = false;
        } else {
          modalMapLink.hidden = true;
          modalMapLink.removeAttribute('href');
        }
      }
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dn-fg-modal-open');
      if (releaseModalFocusTrap) releaseModalFocusTrap();
      releaseModalFocusTrap = createFocusTrap(modalDialog || modal, modalCloseButton || modalDialog);
    };

    const closeModal = () => {
      if (!modal) return;
      if (modalNumber) {
        modalNumber.style.removeProperty('--fg-bubble-color');
      }
      if (modalMapLink) {
        modalMapLink.hidden = true;
        modalMapLink.removeAttribute('href');
      }
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dn-fg-modal-open');
      if (releaseModalFocusTrap) {
        releaseModalFocusTrap();
        releaseModalFocusTrap = null;
      }
      if (lastModalTrigger && typeof lastModalTrigger.focus === 'function') {
        lastModalTrigger.focus();
      } else if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
      lastModalTrigger = null;
    };

    function setMapFullscreen(isOpen) {
      isMapFullscreen = Boolean(isOpen);
      mapRoot.classList.toggle('is-fullscreen', isMapFullscreen);
      document.body.classList.toggle('dn-fg-map-fullscreen', isMapFullscreen);

      if (fullscreenButton) {
        const label = isMapFullscreen ? 'Karte im Vollbild schliessen' : 'Karte im Vollbild öffnen';
        fullscreenButton.setAttribute('aria-pressed', String(isMapFullscreen));
        fullscreenButton.setAttribute('aria-label', label);
        fullscreenButton.setAttribute('title', label);
      }

      window.requestAnimationFrame(() => {
        syncMapFitFrame();
        applyTransform();
        syncDesktopFilterPanelHeight();
      });
    }

    if (zoomInButton) {
      zoomInButton.addEventListener('click', () => {
        setZoomByStep(1);
      });
    }

    if (zoomOutButton) {
      zoomOutButton.addEventListener('click', () => {
        setZoomByStep(-1);
      });
    }

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        zoom = 1;
        panX = 0;
        panY = 0;
        applyTransform(true);
      });
    }

    if (controls) {
      controls.addEventListener('pointerdown', (event) => {
        event.stopPropagation();
      });
      controls.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }

    stage.addEventListener('wheel', (event) => {
      event.preventDefault();
      const factor = Math.exp(-event.deltaY * 0.0015);
      setZoomAtPoint(Number((zoom * factor).toFixed(3)), event.clientX, event.clientY);
    }, { passive: false });

    const getPointerDistance = (first, second) => Math.hypot(first.x - second.x, first.y - second.y);
    const getPointerCenter = (first, second) => ({
      x: (first.x + second.x) / 2,
      y: (first.y + second.y) / 2
    });

    const hardStopDrag = () => {
      activePointers.clear();
      finishGesture();
    };

    const finishGesture = () => {
      dragStart = null;
      pinchStart = null;
      stage.classList.remove('is-dragging');
      gestureMoved = false;
    };

    stage.addEventListener('pointerdown', (event) => {
      const markerTarget = event.target.closest('[data-fg-marker]');
      if (markerTarget && zoom <= 1 && event.pointerType === 'mouse') {
        return;
      }

      if (event.pointerType !== 'mouse') {
        stage.setPointerCapture(event.pointerId);
      }
      activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

      if (activePointers.size === 1) {
        dragStart = {
          pointerId: event.pointerId,
          lastX: event.clientX,
          lastY: event.clientY
        };
        gestureMoved = false;
      }

      if (activePointers.size === 2) {
        const [first, second] = Array.from(activePointers.values());
        pinchStart = {
          distance: getPointerDistance(first, second),
          zoom,
          panX,
          panY
        };
        stage.classList.add('is-dragging');
      }
    });

    stage.addEventListener('pointermove', (event) => {
      if (!activePointers.has(event.pointerId)) return;
      activePointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

      if (activePointers.size === 2 && pinchStart) {
        const [first, second] = Array.from(activePointers.values());
        const distance = getPointerDistance(first, second);
        if (distance <= 0) return;

        const center = getPointerCenter(first, second);
        const nextZoom = Number((pinchStart.zoom * (distance / pinchStart.distance)).toFixed(3));
        setZoomAtPoint(nextZoom, center.x, center.y);
        stage.classList.add('is-dragging');
        return;
      }

      if (activePointers.size === 1 && dragStart && zoom > 1) {
        const dx = event.clientX - dragStart.lastX;
        const dy = event.clientY - dragStart.lastY;
        if (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD) {
          gestureMoved = true;
          suppressMarkerClick = true;
        }
        const bounds = getBounds();
        panX = clamp(panX + dx, bounds.minX, bounds.maxX);
        panY = clamp(panY + dy, bounds.minY, bounds.maxY);
        applyTransform(false, true);
        if (gestureMoved) {
          stage.classList.add('is-dragging');
        }
        dragStart.lastX = event.clientX;
        dragStart.lastY = event.clientY;
      }
    });

    const handlePointerEnd = (event) => {
      activePointers.delete(event.pointerId);

      if (activePointers.size === 1) {
        const remaining = Array.from(activePointers.entries())[0];
        dragStart = {
          pointerId: remaining[0],
          lastX: remaining[1].x,
          lastY: remaining[1].y
        };
        pinchStart = null;
        return;
      }

      if (activePointers.size === 0) {
        if (gestureMoved) {
          suppressMarkerClick = true;
          window.setTimeout(() => {
            suppressMarkerClick = false;
          }, 120);
        }
        finishGesture();
      }
    };

    stage.addEventListener('pointerup', handlePointerEnd);
    stage.addEventListener('pointercancel', handlePointerEnd);
    stage.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse' && activePointers.size > 0) {
        hardStopDrag();
      }
    });
    stage.addEventListener('lostpointercapture', () => {
      hardStopDrag();
    });

    window.addEventListener('pointerup', (event) => {
      if (activePointers.has(event.pointerId)) {
        handlePointerEnd(event);
      } else if (event.pointerType === 'mouse' && activePointers.size > 0) {
        hardStopDrag();
      }
    });

    window.addEventListener('blur', () => {
      if (activePointers.size > 0) {
        hardStopDrag();
      }
    });

    markers.forEach((marker) => {
      marker.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });

      marker.addEventListener('click', (event) => {
        if (suppressMarkerClick) {
          event.preventDefault();
          event.stopPropagation();
          suppressMarkerClick = false;
          return;
        }
        setActiveMarker(marker);
        openModal(marker);
      });
    });

    modalCloseTargets.forEach((entry) => {
      entry.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        toggleFilterPanel(false);
        closeModal();
        setMapFullscreen(false);
      }
    });

    filterInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const groupKey = input.dataset.fgFilterGroup;

        if (groupKey) {
          const escapedGroup = (window.CSS && typeof window.CSS.escape === 'function')
            ? window.CSS.escape(groupKey)
            : groupKey.replace(/"/g, '\\"');
          const groupMarkers = Array.from(mapRoot.querySelectorAll(`[data-fg-group="${escapedGroup}"]`));
          if (!groupMarkers.length) return;

          groupMarkers.forEach((marker) => {
            marker.hidden = !input.checked;
            if (!input.checked && marker.classList.contains('is-active')) {
              setActiveMarker(null);
            }
          });
          return;
        }

        const markerId = input.dataset.fgFilter;
        const marker = mapRoot.querySelector(`[data-fg-marker-id="${markerId}"]`);
        if (!marker) return;

        marker.hidden = !input.checked;
        if (!input.checked && marker.classList.contains('is-active')) {
          setActiveMarker(null);
        }
      });
    });

    const toggleFilterPanel = (isOpen) => {
      mapRoot.classList.toggle('is-filter-open', isOpen);
      document.body.classList.toggle('dn-fg-filter-open', isOpen);
      if (filterToggle) filterToggle.setAttribute('aria-expanded', String(isOpen));
      if (filterToggle) filterToggle.textContent = isOpen ? 'Filter schliessen' : 'Filter öffnen';
      if (filterPanel) {
        filterPanel.setAttribute('aria-hidden', String(!isOpen));
        filterPanel.setAttribute('aria-modal', String(isOpen));
      }

      if (isOpen) {
        lastFocusedElement = document.activeElement;
        if (releaseFilterFocusTrap) releaseFilterFocusTrap();
        releaseFilterFocusTrap = createFocusTrap(filterPanel, filterCloseButton || filterPanel);
      } else {
        if (releaseFilterFocusTrap) {
          releaseFilterFocusTrap();
          releaseFilterFocusTrap = null;
        }
        if (filterToggle && typeof filterToggle.focus === 'function') {
          filterToggle.focus();
        }
      }
    };

    if (filterToggle) {
      filterToggle.addEventListener('click', () => {
        const isOpen = mapRoot.classList.contains('is-filter-open');
        toggleFilterPanel(!isOpen);
      });
    }

    filterCloseTargets.forEach((entry) => {
      entry.addEventListener('click', () => {
        toggleFilterPanel(false);
      });
    });

    if (fullscreenButton) {
      fullscreenButton.addEventListener('click', () => {
        setMapFullscreen(!isMapFullscreen);
      });
    }

    const filterAllButton = mapRoot.querySelector('[data-fg-filter-all]');
    if (filterAllButton) {
      filterAllButton.addEventListener('click', () => {
        filterInputs.forEach((input) => {
          input.checked = true;
          input.dispatchEvent(new Event('change'));
        });
      });
    }

    const filterNoneButton = mapRoot.querySelector('[data-fg-filter-none]');
    if (filterNoneButton) {
      filterNoneButton.addEventListener('click', () => {
        filterInputs.forEach((input) => {
          input.checked = false;
          input.dispatchEvent(new Event('change'));
        });
      });
    }

    let resizeRafId = null;
    const handleViewportResize = () => {
      if (isMapFullscreen && window.matchMedia('(min-width: 992px)').matches) {
        setMapFullscreen(false);
      }
      if (resizeRafId) {
        cancelAnimationFrame(resizeRafId);
      }
      resizeRafId = requestAnimationFrame(() => {
        resizeRafId = null;
        zoom = clamp(zoom, minZoom, getMaxZoom());
        syncMapFitFrame();
        applyTransform();
        syncDesktopFilterPanelHeight();
      });
    };

    window.addEventListener('resize', handleViewportResize, { passive: true });
    window.addEventListener('orientationchange', handleViewportResize, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const stageResizeObserver = new ResizeObserver(() => {
        handleViewportResize();
      });
      stageResizeObserver.observe(stage);
    }

    syncMapFitFrame();
    applyTransform();
    syncDesktopFilterPanelHeight();
    window.requestAnimationFrame(() => {
      syncMapFitFrame();
      applyTransform();
      syncDesktopFilterPanelHeight();
    });
    setActiveMarker(null);
  });
});

  gsap.registerPlugin(ScrollTrigger);

  // Beispiel: Alle Blöcke mit Klasse .dn-section sollen smooth einblenden
  gsap.utils.toArray('.dn-animate').forEach(section => {
    gsap.from(section, {
      opacity: 0,
      y: 0,  // leicht nach unten versetzt starten
      duration: 1.25,
      ease: "power2.out",
      scrollTrigger: {
        trigger: section,
        start: "top 80%",  // Animation starten wenn Sektion zu 80% im Viewport ist
        toggleActions: "play none none none",
        // optional: einmal abspielen, kein Zurücksetzen
      }
    });
  });

  // Beispiel: Alle Blöcke mit Klasse .dn-section sollen smooth einblenden
  gsap.utils.toArray('.dn-block').forEach(section => {
    gsap.from(section, {
      opacity: 0,
      y: 0,  // leicht nach unten versetzt starten
      duration: 1.25,
      ease: "power2.out",
      scrollTrigger: {
        trigger: section,
        start: "top 80%",  // Animation starten wenn Sektion zu 80% im Viewport ist
        toggleActions: "play none none none",
        // optional: einmal abspielen, kein Zurücksetzen
      }
    });
  });

  Fancybox.bind("[data-fancybox]", {
  // Your custom options
});
